module.exports = __webpack_public_path__ + "img/perfume-editorial.bce60fc4.webp";